.field {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.label {
  font-size: var(--text-sm);
  font-weight: var(--weight-medium);
  color: var(--text-secondary);
}

.control {
  position: relative;
  display: flex;
  align-items: center;
}

.input {
  width: 100%;
  height: 42px;
  padding: 0 var(--space-4);
  background: var(--bg-inset);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md);
  color: var(--text-primary);
  font-size: var(--text-base);
  transition:
    border-color var(--duration-fast) var(--ease-out),
    background var(--duration-fast) var(--ease-out);
}

.input::placeholder {
  color: var(--text-tertiary);
}

.input:hover:not(:disabled) {
  border-color: var(--border-strong);
}

.input:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px var(--accent-subtle);
}

.input:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.withLeadingIcon {
  padding-left: 38px;
}

.withTrailing {
  padding-right: 44px;
}

.leadingIcon {
  position: absolute;
  left: 12px;
  display: grid;
  place-items: center;
  color: var(--text-tertiary);
  pointer-events: none;
}

.trailing {
  position: absolute;
  right: 6px;
}

.invalid {
  border-color: var(--danger);
}

.invalid:focus {
  border-color: var(--danger);
  box-shadow: 0 0 0 3px var(--danger-subtle);
}

.error {
  display: flex;
  align-items: center;
  gap: var(--space-1);
  font-size: var(--text-sm);
  color: var(--danger);
}

.hint {
  font-size: var(--text-sm);
  color: var(--text-tertiary);
}

/* Compact search input used in toolbars */
.search {
  height: 34px;
  font-size: var(--text-sm);
}
